import { IAttachmentFile } from 'types';
import { MediaFile, MediaFileId } from './media-file.types';
import {
  getFileExtension,
  getMediaFileType,
  getMimeTypeByFileName,
} from './media-file.utils';

export function createMediaFileFromFile(file: File): MediaFile;
export function createMediaFileFromFile(files: File[]): MediaFile[];

export function createMediaFileFromFile(
  fileOrFiles: File | File[]
): MediaFile | MediaFile[] {
  if (Array.isArray(fileOrFiles)) {
    return fileOrFiles.map((f) => createMediaFileFromFile(f));
  }

  const extension = getFileExtension(fileOrFiles.name);
  const mimeType = getMimeTypeByFileName(fileOrFiles.name);

  return {
    id: crypto.randomUUID() as MediaFileId,
    name: fileOrFiles.name,
    mimeType,
    type: getMediaFileType(mimeType),
    extension,
    status: 'added',
    mediaStatus: 'loaded',
    file: fileOrFiles,
  };
}

export function createMediaFileFromAttachment(
  attachment: IAttachmentFile & { url?: string }
): MediaFile;

export function createMediaFileFromAttachment(
  attachments: (IAttachmentFile & { url?: string })[]
): MediaFile[];

export function createMediaFileFromAttachment(
  attachmentOrAttachments:
    | (IAttachmentFile & { url?: string })
    | (IAttachmentFile & { url?: string })[]
): MediaFile | MediaFile[] {
  if (Array.isArray(attachmentOrAttachments)) {
    return attachmentOrAttachments.map((a) => createMediaFileFromAttachment(a));
  }

  const extension = getFileExtension(attachmentOrAttachments.name);
  const mimeType = getMimeTypeByFileName(attachmentOrAttachments.name);
  const type = getMediaFileType(mimeType);

  return {
    id: crypto.randomUUID() as MediaFileId,
    serverId: attachmentOrAttachments._id,
    name: attachmentOrAttachments.name,
    mimeType,
    type,
    extension,
    status: 'uploaded',
    mediaStatus: type === 'image' ? 'loading' : 'loaded',
    url: attachmentOrAttachments.url,
  };
}
